import { createContext, useContext, ReactNode } from 'react'

interface QcTaskSearchContextType {
  searchValue: string
  setSearchValue: (value: string) => void
}

const QcTaskSearchContext = createContext<QcTaskSearchContextType | undefined>(undefined)

export const QcTaskSearchProvider = ({ children, value }: { children: ReactNode; value: QcTaskSearchContextType }) => {
  return <QcTaskSearchContext.Provider value={value}>{children}</QcTaskSearchContext.Provider>
}

export const useQcTaskSearch = (): QcTaskSearchContextType => {
  const context = useContext(QcTaskSearchContext)
  if (context === undefined) {
    throw new Error('useQcTaskSearch must be used within a QcTaskSearchProvider')
  }
  return context
}
